import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function VolumeModerateIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m17.781 7.04042c1.3752 1.20954 2.2441 2.98108 2.2441 4.95648 0 1.9752-.8691 3.7463-2.2441 4.9558l-.9569-.9568c1.1319-.963 1.851-2.3965 1.851-3.999 0-1.6027-.719-3.03666-1.851-3.99964z" />
        <path d="m15.5989 8.92245c1.0352.63229 1.7262 1.77265 1.7262 3.07445 0 1.3016-.6911 2.4415-1.7262 3.0738l-1.0002-1.0002c.8087-.3411 1.3764-1.1409 1.3764-2.0736 0-.9329-.5676-1.7332-1.3764-2.07425z" />
        <path d="m7.5751 15.1469h-3c-.33137 0-.6-.2683-.6-.5996v-5.10083c0-.33138.26863-.5996.6-.5996h3s1.81682-1.09348 3-2.25c.568-.55516 1.2958-1.42547 1.8923-2.17129.3607-.45096 1.1077-.19972 1.1077.37774v14.39528c0 .5766-.7444.8278-1.1048.3777-.6022-.7521-1.3364-1.6311-1.8952-2.1794-1.20262-1.1802-3-2.25-3-2.25z" />
      </g>
    </SVGWrapper>
  );
}
export default VolumeModerateIcon;
